import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.5 5.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M11.75 2a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5M4.5 6.75c0-.69.56-1.25 1.25-1.25a.75.75 0 0 0 0-1.5 2.75 2.75 0 0 0 0 5.5.75.75 0 0 0 0-1.5C5.06 8 4.5 7.44 4.5 6.75M17.75 5.5a1.25 1.25 0 1 1 0 2.5.75.75 0 0 0 0 1.5 2.75 2.75 0 1 0 0-5.5.75.75 0 0 0 0 1.5m-8 5.5A3.75 3.75 0 0 0 6 14.75v5c0 .966.784 1.75 1.75 1.75h8a1.75 1.75 0 0 0 1.75-1.75v-5A3.75 3.75 0 0 0 13.75 11zM7.5 14.75a2.25 2.25 0 0 1 2.25-2.25h4A2.25 2.25 0 0 1 16 14.75v5a.25.25 0 0 1-.25.25h-8a.25.25 0 0 1-.25-.25zM4.75 12.5c-.69 0-1.25.56-1.25 1.25v5a.75.75 0 0 1-1.5 0v-5A2.75 2.75 0 0 1 4.75 11h.5a.75.75 0 0 1 0 1.5zM20 13.75c0-.69-.56-1.25-1.25-1.25h-.5a.75.75 0 0 1 0-1.5h.5a2.75 2.75 0 0 1 2.75 2.75v5a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }